/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type PartnerScope = typeof PartnerScope[keyof typeof PartnerScope];


export const PartnerScope = {
  'tasks:read': 'tasks:read',
  'tasks:write': 'tasks:write',
} as const;
